'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _base = require('../base');

var _base2 = _interopRequireDefault(_base);

var _defaultProps = require('../default-props');

var _defaultProps2 = _interopRequireDefault(_defaultProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SliderReverse = function (_React$Component) {
	(0, _inherits3.default)(SliderReverse, _React$Component);

	function SliderReverse() {
		(0, _classCallCheck3.default)(this, SliderReverse);
		return (0, _possibleConstructorReturn3.default)(this, (SliderReverse.__proto__ || Object.getPrototypeOf(SliderReverse)).apply(this, arguments));
	}

	(0, _createClass3.default)(SliderReverse, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    lineHeight = _props.lineHeight,
			    lineSpacing = _props.lineSpacing,
			    width = _props.width;


			var yOffset = lineSpacing + lineHeight;

			return _react2.default.createElement(
				_base2.default,
				(0, _extends3.default)({ className: 'BurgerSliderReverse' }, this.props),
				_react2.default.createElement(_style2.default, {
					styleId: '63542277',
					css: '.BurgerSliderReverse .BurgerInner{top:' + lineHeight / 2 + 'px;}.BurgerSliderReverse .BurgerInner:before{top:' + yOffset + 'px;-webkit-transition-property:-webkit-transform,opacity;-webkit-transition-property:transform,opacity;transition-property:transform,opacity;-webkit-transition-timing-function:ease;transition-timing-function:ease;-webkit-transition-duration:0.15s;transition-duration:0.15s;}.BurgerSliderReverse .BurgerInner:after{top:' + yOffset * 2 + 'px;}.BurgerSliderReverse.BurgerActive .BurgerInner{-webkit-transform:translate3d(0,' + yOffset + 'px,0) rotate(-45deg);-ms-transform:translate3d(0,' + yOffset + 'px,0) rotate(-45deg);transform:translate3d(0,' + yOffset + 'px,0) rotate(-45deg);}.BurgerSliderReverse.BurgerActive .BurgerInner:before{-webkit-transform:rotate(45deg) translate3d(' + width / 7 + 'px,' + lineSpacing * -1 + 'px,0);-ms-transform:rotate(45deg) translate3d(' + width / 7 + 'px,' + lineSpacing * -1 + 'px,0);transform:rotate(45deg) translate3d(' + width / 7 + 'px,' + lineSpacing * -1 + 'px,0);opacity:0;}.BurgerSliderReverse.BurgerActive .BurgerInner:after{-webkit-transform:translate3d(0,' + yOffset * -2 + 'px,0) rotate(90deg);-ms-transform:translate3d(0,' + yOffset * -2 + 'px,0) rotate(90deg);transform:translate3d(0,' + yOffset * -2 + 'px,0) rotate(90deg);}\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */\n/*@ sourceURL=../../src/types/slider-reverse.js */',
					dynamic: [lineHeight / 2, yOffset, yOffset * 2, yOffset, width / 7, lineSpacing * -1, yOffset * -2]
				})
			);
		}
	}]);
	return SliderReverse;
}(_react2.default.Component);

exports.default = SliderReverse;


SliderReverse.defaultProps = _defaultProps2.default;
module.exports = exports['default'];
//# sourceMappingURL=slider-reverse.js.map